import { createReducer, INITIAL_STATE } from '../../../shared/redux';

import {
    API_INTEGRATE_URL,
    API_GET_DATA_URL,
} from './woocommerce.constants';

export const WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_CALLED = '@integrations/woocommerce/SAVE_INTEGRATION_REQUEST_CALLED';
export const WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_START = '@integrations/woocommerce/SAVE_INTEGRATION_REQUEST_START';
export const WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_SUCCESS = '@integrations/woocommerce/SAVE_INTEGRATION_REQUEST_SUCCESS';
export const WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_ERROR = '@integrations/woocommerce/SAVE_INTEGRATION_REQUEST_ERROR';

export const WOOCOMMERCE_GET_DATA_REQUEST_CALLED = '@integrations/woocommerce/GET_DATA_REQUEST_CALLED';
export const WOOCOMMERCE_GET_DATA_REQUEST_START = '@integrations/woocommerce/GET_DATA_REQUEST_START';
export const WOOCOMMERCE_GET_DATA_REQUEST_SUCCESS = '@integrations/woocommerce/GET_DATA_REQUEST_SUCCESS';
export const WOOCOMMERCE_GET_DATA_REQUEST_ERROR = '@integrations/woocommerce/GET_DATA_REQUEST_ERROR';

export const getWoocommerceState = state => ({
    ...state.integrations.woocommerce,
});

export type WoocommerceIntegrationData = {
  storeUrl: string
  consumerKey: string
  consumerSecret: string
  clientId: string
}

export const saveWoocommerceIntegration = ({
    storeUrl,
    consumerKey,
    consumerSecret,
    clientId,
}: WoocommerceIntegrationData) => ({
    type: WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_CALLED,
    actionTypes: {
        start: WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_START,
        fail: WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_ERROR,
        success: WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_SUCCESS,
    },
    config: {
        url: API_INTEGRATE_URL,
        method: 'POST',
        data: {
            store_url: storeUrl,
            consumer_key: consumerKey,
            consumer_secret: consumerSecret,
            client_id: clientId,
        },
    },
});

export const getWoocommerceData = ({ clientId }) => ({
    type: WOOCOMMERCE_GET_DATA_REQUEST_CALLED,
    actionTypes: {
        start: WOOCOMMERCE_GET_DATA_REQUEST_START,
        fail: WOOCOMMERCE_GET_DATA_REQUEST_ERROR,
        success: WOOCOMMERCE_GET_DATA_REQUEST_SUCCESS,
    },
    config: {
        url: API_GET_DATA_URL,
        method: 'GET',
        params: {
            client_id: clientId,
        },
    },
});

export type State = {
  loading: boolean
  submitting: boolean
  integrationData: WoocommerceIntegrationData
};

const initialState: State = {
    loading: true,
    submitting: false,
    integrationData: {
        storeUrl: '',
        consumerKey: '',
        consumerSecret: '',
    },
};

export const woocommerceReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_START]: (state: State): State => ({
        ...state,
        submitting: true,
    }),
    [WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_SUCCESS]: (state: State): State => ({
        ...state,
        submitting: false,
    }),
    [WOOCOMMERCE_SAVE_INTEGRATION_REQUEST_ERROR]: (state: State): State => ({
        ...state,
        submitting: false,
    }),
    [WOOCOMMERCE_GET_DATA_REQUEST_START]: (state: State): State => ({
        ...state,
        loading: true,
    }),
    [WOOCOMMERCE_GET_DATA_REQUEST_SUCCESS]: (state: State, { payload: { data } }): State => ({
        ...state,
        loading: false,
        integrationData: {
            storeUrl: data.store_url,
            consumerKey: data.consumer_key,
            consumerSecret: data.consumer_secret,
        },
    }),
    [WOOCOMMERCE_GET_DATA_REQUEST_ERROR]: (state: State): State => ({
        ...state,
        loading: false,
    }),
});
